import React, {useState} from 'react';
import {Action} from '../../../../system/buttons';
import {PremiumWrapperOverlay} from '../../../PremiumWrapperOverlay';
import {ContainerConfiguration} from './ContainerConfiguration';
import {BpmConfiguration} from './BpmConfiguration';
import {IconConfiguration} from './IconConfiguration';

export const BpmAdvancedEdit = (props) => {
  const [configuration, setConfiguration] = useState(props.configuration);

  const updateConfiguration = (configPart) => {
    const newConfiguration = {...configuration, ...configPart};
    setConfiguration(newConfiguration);
    props.onUpdate(newConfiguration);
  };

  return (
    <>
      <PremiumWrapperOverlay
        bi={{
          from: 'widget_edit_premium_update',
          id: props.id,
        }}
        disabled={!props.premiumUpdate}
      >
        <ContainerConfiguration
          configuration={configuration}
          updateConfiguration={updateConfiguration}
        />

        <IconConfiguration
          configuration={configuration}
          updateConfiguration={updateConfiguration}
        />

        <BpmConfiguration
          configuration={configuration}
          updateConfiguration={updateConfiguration}
        />
      </PremiumWrapperOverlay>

      <Action
        onClick={() =>
          props.onSave({
            alignment: configuration.alignment,
            font: configuration.font,
            backgroundColor: configuration.backgroundColor,
            ranges: configuration.ranges,
            layout: configuration.layout,
            outline: configuration.outline,
            image: configuration.image,
            animation: configuration.animation,
          })
        }
      >
        Save settings
      </Action>
    </>
  );
};
